import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, TextField, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import axios from 'axios';

const API_URL = '/api/decoracao';

function Decoracao() {
  const [dados, setDados] = useState([]);
  const [form, setForm] = useState({ responsavel: '', valor: '', extras: '' });
  const [editId, setEditId] = useState(null);

  const fetchDados = async () => {
    const res = await axios.get(API_URL);
    setDados(res.data);
  };

  useEffect(() => {
    fetchDados();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editId) {
      await axios.put(`${API_URL}/${editId}`, form);
    } else {
      await axios.post(API_URL, form);
    }
    setForm({ responsavel: '', valor: '', extras: '' });
    setEditId(null);
    fetchDados();
  };

  const handleEdit = (item) => {
    setForm({ responsavel: item.responsavel, valor: item.valor, extras: item.extras });
    setEditId(item.id);
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API_URL}/${id}`);
    fetchDados();
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Decoração</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <form onSubmit={handleSubmit}>
          <TextField label="Responsável" name="responsavel" value={form.responsavel} onChange={handleChange} required sx={{ mr: 2 }} />
          <TextField label="Valor" name="valor" value={form.valor} onChange={handleChange} required sx={{ mr: 2 }} type="number" />
          <TextField label="Extras" name="extras" value={form.extras} onChange={handleChange} sx={{ mr: 2 }} />
          <Button type="submit" variant="contained" color="primary">{editId ? 'Salvar' : 'Adicionar'}</Button>
          {editId && <Button onClick={() => { setEditId(null); setForm({ responsavel: '', valor: '', extras: '' }); }} sx={{ ml: 2 }}>Cancelar</Button>}
        </form>
      </Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Responsável</TableCell>
            <TableCell>Valor</TableCell>
            <TableCell>Extras</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dados.map((item) => (
            <TableRow key={item.id}>
              <TableCell>{item.responsavel}</TableCell>
              <TableCell>{item.valor}</TableCell>
              <TableCell>{item.extras}</TableCell>
              <TableCell>
                <Button size="small" onClick={() => handleEdit(item)}>Editar</Button>
                <Button size="small" color="error" onClick={() => handleDelete(item.id)}>Excluir</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

export default Decoracao;
